/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";
import { Link } from "react-router-dom";

import { MaterialReactTable } from "material-react-table";
import { Box, MenuItem } from "@mui/material";

import CrmContactListHeader from "../Header/CrmContactListHeader";
import CrmContactFilterPopup from "../Popup/CrmContactFilterPopup";

import AddLabelModal from "components/Common/Modal/AddLabelModal";

import { GlobalProvider } from "context/GlobalContext";

import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";

import AddToListModal from "components/Common/Modal/AddToListModal";
import { crmCommonHeaderLinkLists } from "helper/CrmHelper/CrmHelper";
import ConversationNewMailPopup from "components/Common/Popup/ConversationNewMailPopup";
import { useTranslation } from "react-i18next";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AddAlertModal from "components/Common/Modal/AddAlertModal";
import AddNewContactModal from "../Modal/AddNewContactModal";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import { replaceListByIds } from "helper/Common/CommonHelper";
import CsvCustomUploadModal from "../Modal/CsvCustomUploadModal";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import BulkUnfriendModal from "../Modal/BulkUnfriendModal";

const CrmContactListBody = () => {
  const { t, i18n } = useTranslation();
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { reloadContactList, setReloadContactList } =
    useContext(GlobalProvider);

  const commonHeaderObject = crmCommonHeaderLinkLists(t);
  const token = localStorage.getItem("token");

  // showSkeleton = true  → show skeleton (initial load + filter apply/reset)
  // showSkeleton = false → show table (search typing, pagination, etc.)
  const [showSkeleton, setShowSkeleton] = useState(false);

  const [contactList, setContactList] = useState([]);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedContactIds, setSelectedContactIds] = useState([]);
  const [selectUserIds, setSelectUserIds] = useState([]);
  const [selectedUserEmails, setSelectedUserEmails] = useState("");
  const [selectedContactNames, setselectedContactNames] = useState("");
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [isDataReady, setIsDataReady] = useState(false);

  const [isBulkProcessing, setIsBulkProcessing] = useState(false);

  const [showAllRecords, setShowAllRecords] = useState(false);

  // null = filter popup hasn't decided yet, skip API call
  // []   = no default filter, fetch all
  // [...] = has filters, fetch filtered
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  // Global search states — MRT search is manual (server-side)
  const [globalSearch, setGlobalSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // withSkeleton = true  → show skeleton while loading (initial load, filter apply/reset)
  // withSkeleton = false → no skeleton (search typing — table stays visible)
  const getAllContactList = async (
    filterQuery = [],
    searchTerm = "",
    withSkeleton = false,
    showallcontacts = false,
  ) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_CONTACTS +
        `?token=${token}&showallcontacts=${showallcontacts}`;

      // Append filter conditions if present
      if (filterQuery.length > 0) {
        const sanitizedQuery = filterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","),
            };
          }
          return filter;
        });

        const encodedFilters = encodeURIComponent(
          JSON.stringify(sanitizedQuery),
        );
        requestUrl += `&filters=${encodedFilters}`;
      }

      // Append search term if present
      if (searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("url of contact list------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in contact list------>", response);

      if (response.status) {
        setContactList(response.data);
        setMessageType("success");
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowSkeleton(false);
      setShowAlert(true);
    }
  };

  const unfriendHandler = async (personId) => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_UNFRIEND_CONTACT +
        `?token=${token}&personid=${personId}`;

      const response = await putData(requestURL);

      console.log(response);

      if (response.status) {
        setMessageType("success");
        setTimeout(() => getAllContactList(), 2500);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  const removeTagFromContact = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_LABEL_CONTACT;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedContactId(null);
      }, 1000);
    }
  };

  const bulkUnfriendHandler = async () => {
    try {
      if (selectUserIds.length === 0) return;

      setIsBulkProcessing(true);

      let requestURL =
        url.API_BASE_URL + url.API_BULK_UNFRIEND_CONTACT + `?token=${token}`;

      const response = await putData(requestURL, {
        personids: selectUserIds,
      });

      if (response.status) {
        setMessageType("success");
        setAlertMessage(response.message);

        // reset selection
        setRowSelection({});
        setSelectedContactIds([]);
        setSelectUserIds([]);

        setTimeout(() => {
          setContactList((prev) =>
            prev.filter((item) => !selectUserIds.includes(item.userid)),
          );
        }, 1000);
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    } finally {
      setIsBulkProcessing(false);
      setShowAlert(true);

      let modal = document.querySelector("#bulkUnfriendModal");
      let instance = bootstrap.Modal.getInstance(modal);
      instance?.hide();
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setContactList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  const afterEmailClose = () => {
    setRowSelection({});
    setSelectedContactIds([]);
    setSelectUserIds([]);
    setSelectedUserEmails("");
  };

  const handleCloseAddContactsModal = (data = []) => {
    if (data.length > 0) {
      setContactList((prevContacts) => [...data, ...prevContacts]);
    }
  };

  const initialTableColumns = [
    {
      accessorKey: "contactname",
      header: t("Name"),
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            width: "250px",
          }}
        >
          <img
            height={30}
            width={30}
            src={
              row.original.contactimage
                ? url.SERVER_URL + row.original.contactimage
                : assetImages.defaultUser
            }
            loading="lazy"
            style={{ borderRadius: "50%" }}
          />
          <span>{renderedCellValue}</span>
          <button
            onClick={() => {
              createContactChatHandler(row.original.userid, "MOD_CONTACT");
            }}
            className={
              row.original.userid === userInfo._id
                ? "d-none"
                : "d-flex align-items-center ms-auto border-0 bg-light"
            }
          >
            <span className="d-block material-symbols-outlined icon-md text-primary">
              chat
            </span>
          </button>
        </Box>
      ),
    },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.taglist.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.taglist.map((tag, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium me-1">
                        {tag.title}
                      </span>
                      <Link
                        to="#"
                        className={`${
                          tag.moderator.toString() ===
                            userInfo._id.toString() ||
                          userInfo.role.slug === "ADMIN" ||
                          userInfo.role.slug === "SUPER_ADMIN"
                            ? "d-block"
                            : "d-none"
                        }`}
                        onClick={() => {
                          setSelectedContactId(row.original._id);
                          setSelectedTagId(tag._id);
                          removeTagFromContact([tag._id], row.original._id);
                        }}
                      >
                        {selectedTagId &&
                        selectedTagId === tag._id &&
                        selectedContactId &&
                        selectedContactId === row.original._id ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary ms-1"
                            role="status"
                            style={{ height: "12px", width: "12px" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <span
                            className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                            style={{ cursor: "pointer" }}
                          >
                            cancel
                          </span>
                        )}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedContactIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    { accessorKey: "contactemail", header: t("Email") },
    { accessorKey: "contactposition", header: t("Position") },
    { accessorKey: "contactcompany", header: t("Company") },
    { accessorKey: "contactphone", header: t("Phone") },
    { accessorKey: "contactcity", header: t("City") },
    { accessorKey: "contactcountry", header: t("Country") },
    { accessorKey: "lastcontactdate", header: t("Last Contact Date") },
    { accessorKey: "lastcontactsubject", header: t("Last Contact Subject") },
    { accessorKey: "lastcontactchannel", header: t("Last Contact Channel") },
    { accessorKey: "lastresponsedate", header: t("Last Response Date") },
    { accessorKey: "lastresponsesubject", header: t("Last Response Subject") },
    { accessorKey: "lastresponsechannel", header: t("Last Response Channel") },
  ];

  const columns = useMemo(
    () => initialTableColumns,
    [i18n.language, contactList, selectedContactId, selectedTagId],
  );

  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  const onColumnVisiblityHandler = (newColumnState) => {
    const newColumnStateName = newColumnState();
    setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
  };

  const initialColumnOrder = [
    "mrt-row-actions",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  const resetFilterData = () => {
    afterEmailClose();
    setGlobalSearch("");
    setJsonFilterQuery([]); // reset to empty array (not null) — triggers fetch all
    setLastPagination({ pageIndex: 0, pageSize: 10 });
    setPagination({ pageIndex: 0, pageSize: 10 });
    setShowAllRecords(false);
    setReloadData(true);
  };

  const refreshRecords = () => {
    resetFilterData();
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  // ─── Pagination ───────────────────────────────────────────────────────────────────
  useEffect(() => {
    setLastPagination({
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  // ─── Row selection ───────────────────────────────────────────────────────────────
  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );

    if (selectedIdsArray.length > 0) {
      const selectedContactIds = selectedIdsArray.map((id) => {
        const [contactId] = id.split("/");
        return contactId;
      });

      const selectUserIds = selectedIdsArray.map((id) => {
        const [, userId] = id.split("/");
        return userId;
      });

      const selectUserEmails = selectedIdsArray.map((id) => {
        const [, , userEmail] = id.split("/");
        return userEmail;
      });

      setSelectedUserEmails(selectUserEmails.join(","));
      setSelectedContactIds(selectedContactIds);
      setSelectUserIds(selectUserIds);

      if (selectedIdsArray.length === 1) {
        const [, , , contactName] = selectedIdsArray[0].split("/");
        setselectedContactNames(contactName);
      } else {
        setselectedContactNames("");
      }
    } else {
      setSelectedContactIds([]);
      setSelectUserIds([]);
      setSelectedUserEmails("");
    }
  }, [rowSelection]);

  // ─── Debounce global search — 600ms ─────────────────────────────────────────
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(globalSearch);
    }, 600);
    return () => clearTimeout(handler);
  }, [globalSearch]);

  // Reload when triggered from global context (e.g. after adding a contact)
  useEffect(() => {
    if (reloadContactList) {
      getAllContactList(jsonFilterQuery ?? []);
      setReloadContactList(false);
    }
  }, [reloadContactList]);

  // Single API trigger — fires only after filter popup has set jsonFilterQuery.
  // null means popup hasn't responded yet, so we wait.
  // [] means no default filter — fetch all.
  // [...] means filters exist — fetch filtered.
  useEffect(() => {
    if (jsonFilterQuery === null) return;

    if (jsonFilterQuery.length > 0) {
      getAllContactList(jsonFilterQuery, debouncedSearch, true);
    } else {
      getAllContactList([], debouncedSearch, true);
    }

    setIsDataReady(true);
  }, [jsonFilterQuery]);

  // Search effect — fires when debounced search changes.
  // Skeleton OFF — table stays visible while searching.
  // Priority: showAllRecords > jsonFilterQuery > default
  useEffect(() => {
    if (!isDataReady) return;

    if (showAllRecords) {
      getAllContactList([], debouncedSearch, false, true); // ✅ show all records + debounce search
    } else if (jsonFilterQuery && jsonFilterQuery.length > 0) {
      getAllContactList(jsonFilterQuery, debouncedSearch, false);
    } else {
      getAllContactList([], debouncedSearch, false);
    }
  }, [debouncedSearch]);

  // Reload effect triggered by reset or refresh
  useEffect(() => {
    if (reloadData) {
      setGlobalSearch("");
      setIsFilterReset(true);
      getAllContactList([], "", true);
      setReloadData(false);
      setIsDataReady(true);
    }
  }, [reloadData]);

  // ─── Alert notification ───────────────────────────────────────────────────────────
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") && moduleAccess.includes("MOD_CONTACT"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Contact")}
          />

          <div className="container-fluid px-lg-5">
            <CrmContactListHeader
              reloadList={refreshRecords}
              jsonFilterQuery={jsonFilterQuery ?? []}
              selectedContactIds={selectedContactIds}
              showAllContactsHandler={() => {
                setShowAllRecords(true);
                getAllContactList([], "", true, true);
              }}
            />
            {showSkeleton || !isDataReady ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={contactList}
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) =>
                    `${row._id}/${row.userid}/${row.contactemail}/${row.contactname}`
                  }
                  onRowSelectionChange={setRowSelection}
                  // Server-side search — MRT won't filter locally
                  onGlobalFilterChange={(value) => setGlobalSearch(value ?? "")}
                  state={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                    globalFilter: globalSearch || undefined,
                  }}
                  onPaginationChange={setPagination}
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  enableColumnOrdering={true}
                  renderRowActionMenuItems={({ row }) => {
                    const [contactId, userId] = row.id.split("/");

                    const menuItems = [
                      <MenuItem key="timeline">
                        <Link
                          className="dropdown-item"
                          to={`/admin/crm/contact/details/timeline/${contactId}`}
                        >
                          {t("View Timeline")}
                        </Link>
                      </MenuItem>,
                      <MenuItem key="contacttask">
                        <Link
                          className="dropdown-item"
                          to={`/admin/crm/contact/details/task/${contactId}`}
                        >
                          {t("View Task")}
                        </Link>
                      </MenuItem>,
                      <MenuItem key="contactmail">
                        <Link
                          className="dropdown-item"
                          to={`/admin/crm/contact/details/recievedmail/${contactId}`}
                        >
                          {t("View Communication")}
                        </Link>
                      </MenuItem>,
                    ];

                    if (
                      userInfo.role.slug === "ADMIN" ||
                      userInfo.role.slug === "SUPER_ADMIN" ||
                      (moduleAccess.includes("MOD_CRM") &&
                        moduleAccess.includes("MOD_OPPORTUNITY"))
                    ) {
                      menuItems.splice(
                        3,
                        0,
                        <MenuItem key="contactopportunity">
                          <Link
                            className="dropdown-item"
                            to={`/admin/crm/contact/details/opportunities/${contactId}`}
                          >
                            {t("View Opportunities")}
                          </Link>
                        </MenuItem>,
                      );
                    }

                    menuItems.push(
                      <MenuItem
                        key="unfriend"
                        onClick={() => unfriendHandler(userId)}
                      >
                        <Link className="dropdown-item" to="#">
                          {t("Unfriend Connect")}
                        </Link>
                      </MenuItem>,
                    );

                    return menuItems;
                  }}
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        <AddToListModal
          moduleName="contact"
          selectedIds={selectUserIds}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          afterModalClose={() => {
            setSelectedContactIds([]);
            setRowSelection({});
            setSelectUserIds([]);
          }}
        />

        <CrmContactFilterPopup
          moduleSlug="crmcontact"
          visibleColoumns={visibleColoumns}
          setVisibleColoumns={setVisibleColoumns}
          columnOrder={columnOrder}
          setColumnOrder={setColumnOrder}
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={refreshRecords}
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
          columns={columns}
        />

        <AddLabelModal
          selectedIds={selectedContactIds}
          moduleName="crmcontact"
          afterTagModalClose={afterModalActionClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          onModalClose={() => {
            setSelectedContactIds([]);
            setRowSelection({});
          }}
        />

        <ConversationNewMailPopup
          contactPersonEmail={selectedUserEmails}
          reloadList={afterEmailClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          moduleSlug="MOD_CONTACT"
        />

        <AddAlertModal
          selectedIds={selectedContactIds}
          alertSubject={selectedContactNames}
          afterModalClose={() => {
            setSelectedContactIds([]);
            setRowSelection({});
          }}
          moduleName={"contact"}
        />

        <AddNewContactModal
          afterCloseModalHandler={() => {}}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        <CsvCustomUploadModal afterModalClose={handleCloseAddContactsModal} />

        <BulkUnfriendModal
          selectedContactIds={selectedContactIds}
          onConfirm={bulkUnfriendHandler}
          onCancel={() => {
            setRowSelection({});
            setSelectedContactIds([]);
            setSelectUserIds([]);
          }}
          isProcessing={isBulkProcessing}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};
export default CrmContactListBody;
